import * as bootstrap from 'bootstrap';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, Inject, ChangeDetectorRef } from "@angular/core";
import { GlobalComponent } from "src/app/global/global.component";
import { Modal } from 'bootstrap';
import {
  CaregiverInfoLst, 
  ClientAuthBO, 
  ClientBO, 
  ClientReturnBO, 
  ContactInfoLst, 
  disablePortalBO, 
  EditDetailsClient, 
  EmergencyContactInfoLst, 
  GetUserBo, 
  OfficeCaseManagerInfoLst, 
  onBoardingListBO, 
  ResponsibleInfoLst, 
  SendToPortalBO, 
  EmployerEmployeeRelationshipTaxPercentBO, 
  GetListBO, 
  GetListBase, 
  WhereCondition, 
  functionpermission, 
  EditDetailsAuthorization, 
  AuthorizationFilterBo,
  EditSOCDetails,
 AssignCaseManager, GetClientCasemanager, getMappedCMDataBO, ClientCaseManagerRelationshipBO,
  StartOfCareBO,
  carecoordinate,
  ClientCoordinatorRelationshipBO,
  CareCoordinatorInfoLst,
  GetClientCarecoordinator,
  AssignCareCoordinator,
  qpList,
  QPHistoryLst,
  editcertificate,
  UtilizationBO,
  authpermission,
  AssignFMSAgency,
  FMSAgencyrInfoLst,
  GetClientFMSAgency,
  ClientfmsagencyrRelationshipBO,
  ClienthhaagencyrRelationshipBO,
  AssignHHAAgency,
  GetClientHHAAgency,
  HHAgencyInfoLst,
} from "../client-parent.model";
import { IMyInputFieldChanged, IMyDateModel, IMyDpOptions } from "mydatepicker";
import { GeneralService } from "src/app/service/general.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DataStateChangeEventArgs, GridComponent, FilterSettingsModel } from "@syncfusion/ej2-angular-grids";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { DateService } from 'src/app/date.service';
import { ToastrService } from "ngx-toastr";
import { CommonHttpService } from "src/app/common.service";
import { BudgetImportBO } from "../../budgetplan-form/budgetplan-form.model";
import { EnvironmentService } from "src/app/environment.service";
import { ClientEmployeeContactBO } from "../../client-employee-contact/client-employee-contact.model";
import { ClientEmployeeRelationshipBO } from "../../client-employee-relationship/client-employee-relationship.modal";
import { ClientHttpService } from "../client-parent.service";
import { clienttserivce } from "../clienttservice";
import { clienttserivcetax } from "../clientttaxservice";
import { purchaseBo } from "../../purchase-request/purchase-request.model";
import { ClientEmployeeDynamicFormBO } from "../../client-employee-dynamicform/client-employee-dynamicform.model";
import { ClientTabBO } from "../../consultation-services/consultation-services.modal";
import { DocumentDataBO } from "../../client-employee-document/client-employee-document.model";
import { ServiceDeliveryPlan } from "../../serviceplan-form/serviceplan-form.model";
import { LanguageMappingSaveBO } from "../../employee/employee.model";
import { CommonApiService } from "src/app/commonapiservice";
import { CLientMonitorBO } from "../../monitorlist/monitorlist.model";
import { EmitMonitorList } from "../../client-monitorlist/client-monitorlist.model";
import { CaseManagerComponent } from "../../case-manager/case-manager.component";
import { caseManagerList } from "../../case-manager/case-manager.model"; import { ClientCreateEditCareService } from "./client-create-editcare.service";
import { isFunction } from "util";
import { Fmsagency } from '../../fms-agency/fms-agency.model';
import { Homehealthagency } from '../../home-health-agency/home-health-agency.model';

@Component({
  selector: "app-client-create-edit",
  templateUrl: "./client-create-edit.component.html",
  styleUrls: ["./client-create-edit.component.scss"],

})


export class ClientCreateEditComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridcarecoordinator') public gridcarecoordinator: GridComponent;
  @ViewChild('gridfmsagency') public gridfmsagency: GridComponent;
  @ViewChild('gridhhaagency') public gridhhaagency: GridComponent;

  // @ViewChild('gridcasemanager') public caseenablegridcasemanager: GridComponent;
  @Input() DataFromList: EditDetailsClient = new EditDetailsClient();
  @Output() EventToEdit = new EventEmitter<EditDetailsClient>();
  // Event Emitter
  @Input() DataFromSOCEdit: EditSOCDetails = new EditSOCDetails();
  EditSOCOptions: EditSOCDetails = new EditSOCDetails();
  Lsoclist: StartOfCareBO[] = [];
  CLientSOCList: [{ Key: string; Value: string }];
  EditSOC: boolean = false;


  RelationshipId: string | null;
  RelationForm: FormGroup;
  relationtaxform: FormGroup;
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public formatOptions: object
  arraycol: any = [];
  initialPage: any;
  filterOptions: FilterSettingsModel;
  RelationTaxPercentGridBO: GetListBO = new GetListBO();
  stateList: any = [];
  ///General tab////
  savedList: ClientBO;
  ClientErrList: string[] = [];
  ActiveTab = "nav-general";
  previousTab: string = "";
  contactvaluechange: boolean = false;
  today = new Date();
  isEinList: any = [];
  disableEin: boolean = false;
  clientphone1Err: boolean = false;
  clientphone2Err: boolean = false;
  billto: boolean = false;
  userList: GetUserBo[] = [];
  PriorityStatus: any;
  clientemployeenamedropdown: any;
  relationdropdown: any;
  relationtaxdropdown: any;
  selectedLanguages: any = [];
  TypeofWaiver: any;
  saveClientInProgress: boolean = false;
  email_formvalidator: FormGroup;
  isViewUpdate: boolean = false;
  isAuthView: boolean = false;
  isNotes: boolean = false;
  statusList: any = [];
  locationList: any = [];
  genderList: any = [];
  isEditDisable: boolean;
  isShowFields: boolean;
  clientEvv: boolean = false;
  isRelationcontact: boolean = false;
  isconsultationform: boolean = false;
  isEnabledcontact: boolean = false;
  isRelationShip: boolean = false;
  isEnabledRelationship: boolean = false;
  isEnabledNotes: boolean = false;
  isRelationShipTaxPercent = false;
  cfssModel = ['AGENCY', 'BUDGET'];
  PaySourceitem: any = [];
  QPHistoryinfo: QPHistoryLst = new QPHistoryLst();
  qpinfo: qpList = new qpList();
  AddressGoogleMap: boolean = false;
  @Input() GoogleMapList: any;
  @Output() GoogleMapEmit = new EventEmitter<any>();


  employeremployeerelationshipTaxPercentBO: EmployerEmployeeRelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();
  ClientEmployeeContact: ClientEmployeeContactBO = new ClientEmployeeContactBO();
  Consultationform: ClientTabBO = new ClientTabBO();
  ClientAuthList: ClientAuthBO = new ClientAuthBO();
  ClientEmployeeRelationship: ClientEmployeeRelationshipBO = new ClientEmployeeRelationshipBO();
  isFieldEnabled: boolean = false;
  changevalue: boolean = false;
  pcaType: any = [];
  ShowAssessmentRate: string;
  AssessmentRating: any;
  purchaseEmitBo = new purchaseBo()
  getLocationList: any = [];
  supervisiondate: any;
  clientcasemanagerandContactDetail: any;
  ClientList: any = new ClientBO();
  Responsibleinfo: ResponsibleInfoLst = new ResponsibleInfoLst();
  Caregiversdetailsinfo: CaregiverInfoLst = new CaregiverInfoLst();
  EmergencyContactinfo: EmergencyContactInfoLst = new EmergencyContactInfoLst();
  OfficeCaseManagerinfo: OfficeCaseManagerInfoLst =
    new OfficeCaseManagerInfoLst();

// certificate tab  
EditCertificateoption: editcertificate = new editcertificate();
Editcert: boolean = false;

  
  ///conatct tab///

  FilterList: string = "active";
  contactinfo: ContactInfoLst = new ContactInfoLst();
  contactfilter: any = "contacts";
  ContactInfoType: string = "edit";
  casetype: string;
  ContactInfoForm: FormGroup;
  ClientContactData: ContactInfoLst[] = [];
  ContactTypeList: any;
  DocumentListbool: boolean = false;
  showQpInfoComponent: boolean = false;

  conatactRelList: [{ Key: string, Value: string }];
  phoneCarrierList: [{ Key: string, Value: string }];
  languageList: any = [];
  ContactRelationshipList: [{ Key: string, Value: string }];
  relationenable: boolean = false;
  enablerelation: boolean = false;
  //contact tab casemanager//

  DocumentListType: DocumentDataBO = new DocumentDataBO();
  public datacase: Observable<DataStateChangeEventArgs>;
  deletecaseId: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  caseenable: boolean = false;
  assignCase: AssignCaseManager = new AssignCaseManager()
  CaseManagerDropdownList: any = [];
  getClientCasemanager: GetClientCasemanager = new GetClientCasemanager();
  caseLst: getMappedCMDataBO[] = [];
  saveclientcase: ClientCaseManagerRelationshipBO =
    new ClientCaseManagerRelationshipBO();
  AssignCaseManagerBoolean: boolean = false;
  assignCaseManager: any = null;

  @ViewChild("gridcasemanager") public gridcasemanager: GridComponent;

  //contact tab carecoodinator//
  deletecareId: string;
    deletefmsId: string;
    deletehhaId:string;
  careenable: boolean = false;
  fmsagencyenable: boolean = false;
  hhaagencyenable: boolean = false;
  caretype: string = "";
  fmsagencytype:string="client"
  hhaagencytype:string="client"

  isEditBoolean: boolean = false;
  isEditgeneralBoolean: boolean = false;
  isgeneraltabfieldview: boolean = false;

  public datacare: Observable<DataStateChangeEventArgs>;
  public datafms: Observable<DataStateChangeEventArgs>;
    public datahha: Observable<DataStateChangeEventArgs>;

  public data: Observable<DataStateChangeEventArgs>;
  ClientDataForm: FormGroup;


  assignCare: AssignCareCoordinator = new AssignCareCoordinator()
  assignfms: AssignFMSAgency = new AssignFMSAgency()
    assignhha: AssignHHAAgency = new AssignHHAAgency()

  CareCoordinatorinfo: CareCoordinatorInfoLst = new CareCoordinatorInfoLst();
  FMSAgencyinfo: FMSAgencyrInfoLst = new FMSAgencyrInfoLst();
  HHAAgencyinfo: HHAgencyInfoLst = new HHAgencyInfoLst();

  CareCoordinatorDropdownList: any = [];
  FMSAgencyDropdownList: any = [];
    HHAAgencyDropdownList: any = [];

  CareId: string = "";
  getClientCare: GetClientCarecoordinator = new GetClientCarecoordinator();
  getClientFMS: GetClientFMSAgency = new GetClientFMSAgency();
    getClientHHA: GetClientHHAAgency = new GetClientHHAAgency();

  assignCareCoordinator: any = null;
  assignfmsagency: any = null;
  assignhhaagency: any = null;

  addnewcareplan;
  areList: any = [];
  CareListDub: any = [];
  statusFilter: any;
  StatusLst: any;
  CareStatus: any;
  fmsStatus: any;
    hhaStatus: any;
  AssignCareCoordinatorBoolean: boolean = false;
  AssignfmsagencyBoolean: any = null;
  AssignhhaagencyBoolean: any = null;

  carecoLst: carecoordinate[] = [];
  fmsagencyLst: Fmsagency[] = [];
  hhaagencyLst: Homehealthagency[] = [];

  saveclientcare: ClientCoordinatorRelationshipBO =
    new ClientCoordinatorRelationshipBO();
  saveclientfms: ClientfmsagencyrRelationshipBO =
    new ClientfmsagencyrRelationshipBO();
  saveclienthha: ClienthhaagencyrRelationshipBO =
    new ClienthhaagencyrRelationshipBO();


  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };
  fp: authpermission = new authpermission();
  NewPassword: string;
  ConformPassword: string;
  saveorUpdateLanguageError: string = "";

  EmitMonitorList: EmitMonitorList = new EmitMonitorList();
  CaseStatus: any;
  StatusFilterLst: any ;
  ColumnArray_care: any;
  TypeofClient: any;
  isUtilization: boolean = false;
  UtilizationListType: UtilizationBO = new UtilizationBO();
  currentDateTime : string;
  clienttab : string = 'clienttab'
  csfilter: string ='engagement';
  isCheckingReferral: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    public dateservice: DateService,
    public EnvironmentService: EnvironmentService,
    public http: HttpClient,

    private commonhttp: CommonHttpService,
    public ClientService: ClientHttpService, @Inject(clienttserivcetax)
    public clienttserivcetax: clienttserivcetax,
    public toasterService: ToastrService,
    public global: GlobalComponent,

    private general: GeneralService,
    private formBuilder: FormBuilder,
    fb: FormBuilder,
    public CommonAPI: CommonApiService,
    public toastrService: ToastrService,
    public CCESCare: ClientCreateEditCareService,
    public httpService: ClientHttpService) {
    this.data = CommonAPI;
    this.datacare = CCESCare;
    this.datafms=CCESCare
        this.datahha=CCESCare
    this.data = clienttserivcetax
    this.global.checkforlogout();
    this.datacase = CommonAPI;
    // this.datacase = clienttserivce
    // ...................ClientDataForm..........................................
    this.ClientDataForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      //   dateofBirth: new FormControl('', [Validators.required]),
      genderLid: new FormControl('', [Validators.required]),
      statusLid: new FormControl('', [Validators.required]),
      locationId: new FormControl('', [Validators.required]),
      middleName: new FormControl(''),
      ClientPhone1: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      ClientPhone2: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),

      insuranceNo: new FormControl('', [Validators.maxLength(20)]),
      PaySourceLid: new FormControl('', [Validators.required]),
      clientTypeLid:new FormControl('', [Validators.required]),
      typeofWaiverLid: new FormControl('', [Validators.required]),
      medicaid : new FormControl('', [Validators.required]),
      medicare : new FormControl('', [Validators.required]),
      //   ClientEmail: new FormControl('', [Validators.email]),
      ClientEmail: new FormControl('', [

        Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      ]),

      // username: new FormControl(""),

    });
    this.email_formvalidator = this.formBuilder.group({
      Email: ['', [Validators.email, Validators.required]],
    });


    //////////////////// RelationshipTax form ///////////////////////////////////////////
    this.relationtaxform = fb.group({
      employerEmployeeRelationshipId: [' '],
      employerEmployeeRelationshipTaxId: [''],
      percent: [''],
      effectiveDate: [''],




    })


  }

  ngOnInit(): void {
    this.global.viewEmployeeTabs = false; //....... boolean for AllTabs ..........//
    this.global.referralId = "00000000-0000-0000-0000-000000000000"
    this.currentDateTime = new Date().toISOString().slice(0, 16);
       if (this.global.clientId != "00000000-0000-0000-0000-000000000000" && !!this.global.clientId) {
      this.ActiveTab = "nav-notes";
      this.isNotes = true;
      this.getClientcasemanagerandContactDetails();
    }
  this.filterOptions = { type: "Menu" };
    this.global.clientId = this.DataFromList.clientId;
    this.CommonAPI
      .getStateJson()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });

    this.EditOptions.ClientId = this.DataFromList.clientId;
    if (this.global.CxCustomerName != null && this.global.CxCustomerName != undefined && this.global.CxCustomerName != '') {


      this.ActiveTab = "nav-documents";
      this.parentToOnboard.docToOnboarding = true;
      this.parentToOnboard.clientid = this.ClientList.id;
      this.isdynamicFormcontact = true;
    }
    // this.getTabActiveData(this.ActiveTab);
    this.getLocationDropDown();
    this.getStatus();
    this.getClientType();
    this.getMonitorList();
    // this.getPCATYPE();
    // this.getPhoneCarrierStatus()
    // this.getAssessmentRating();
    // this.getContactRelationStatus()
    this.getTypeofWaiver();
    this.getpaysource();
    // this.getPriorityStatus();
    // this.getYesOrNoList();
    this.getGender();
    // this.getRelationStatus();
    this.getStatesField();
    // this.getLiveWithStatus();
    // this.getrelationtaxpercentDataList();
    this.checkValidationforClient();
    // this.getLanguage();
    // this.GetLanguageList()
    this.getLanguageList();

    this.getStatusforCase();
    this.getStatusforFilter();
    this.ClientEmployeeContact.Id = this.global.clientId;
    this.ClientEmployeeContact.ContactType = "Client";
    this.Consultationform.ClientId = this.global?.clientId;
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };

    //////////////// Set ClientId for Contact & Relation & Budget /////////////////////
    this.ClientEmployeeContact.ContactType = 'Client';
    this.ClientEmployeeContact.Id = this.DataFromList.clientId;

    this.ClientEmployeeDynamicForm.Id = this.global.clientId;
    this.ClientEmployeeDynamicForm.Dynamictype = "Client";
    this.ClientEmployeeRelationship.RelationshipType = 'Client';
    this.ClientEmployeeRelationship.Id = this.DataFromList.clientId;
    this.ClientAuthList.Id = this.DataFromList.clientId;
    this.ClientList.phone1 = (this.ClientList.phone1 != null && this.ClientList.phone1 != "" && this.ClientList.phone1 != undefined) ? 
      this.ClientList.phone1 : "";

    this.ClientList.phone2 = (this.ClientList.phone1 != null && this.ClientList.phone1 != "" && this.ClientList.phone1 != undefined) ? 
      this.ClientList.phone2 : "";
      this.ClientList.referralDate = this.datepipe.transform(this.DataFromList.clientData.referralDate,  "yyyy-MM-dd HH:mm:ss");
    this.DocumentListType.Id = this.DataFromList.clientId;
    this.DocumentListType.isDocumentVerified = "Client";
    this.getClientLanguages();
    this.authTypeFilter.TypeFilter = this.FilterList;
    if (this.global.clientId != "00000000-0000-0000-0000-000000000000") {
      this.isEditDisable = true;
      this.isFieldEnabled = true;
      this.email_formvalidator.controls['Email'].disable();
      this.getClientcasemanagerandContactDetails();
    }
    else {
      this.isFieldEnabled = true;
    }
    this.UtilizationListType.clientId= this.global.clientId;
    this.UtilizationListType.clientName=this.ClientList.name;
    this.global.clientName = this.ClientList.name;
    this.UtilizationListType.isInsideClient=true;

    this.getpermission();
  }

  /////////////////////// select and Update language list  /////////////////////////

  LanguageChange(event) {
    this.ShowAssessmentRate = event.Value;
  }


  getLanguageList() {
    let url = "api/Language/GetLanguageList";
    this.ClientService
      .GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.languageList = data;
        },
        (err: any) => {
          this.toasterService.error(err);
        }
      );
  }

  getpaysource() {
    let params = new URLSearchParams();
    params.append("listCode", "PAYSOURCE");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.PaySourceitem = data;

    })
  }




  /////////////////////// validation for client /////////////////////////

  checkValidationforClient() {
    if (this.ClientList.id == "00000000-0000-0000-0000-000000000000") {
      this.ClientDataForm.enable();
      this.global.viewTabs = false;
      this.isgeneraltabfieldview= false;

    }
    else {
      this.isEditBoolean = true;
      this.global.viewTabs = true;   
      this.isgeneraltabfieldview= true;
      this.ClientDataForm.disable();
      this.isEditgeneralBoolean= true;

    }
  }



  ////////////////////////// DATE FORMATCHANGE ////////////////////////
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'EffectiveDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.employeremployeerelationshipTaxPercentBO.effectiveDate = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'EffectiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.employeremployeerelationshipTaxPercentBO.effectiveDate = element;
        }
      }
    }
  }


  //======================================================== EDIT CLIENT=============================================//

  EditClientDetails() {
    this.isViewUpdate = true; //......... boolean for Updateclient.......//
    this.isFieldEnabled = false; //....... boolean for Field disable ..........//
    this.isEditBoolean = false; //......... boolean for Editclient......//
    this.global.viewTabs = false; //....... boolean for AllTabs ..........//
    this.isgeneraltabfieldview= false;
   this.ClientDataForm.enable();
    
  }

  EditClientgeneraltab() {
    this.isViewUpdate = true; //......... boolean for Updateclient.......//
    this.isFieldEnabled = false; //....... boolean for Field disable ..........//
    this.isEditgeneralBoolean = false; //......... boolean for Editclient......//
    this.isgeneraltabfieldview= false; // general tab fields
   // this.global.viewTabs = false; //....... boolean for AllTabs ..........//
    this.ClientDataForm.enable();
    
  }


  //===========================================================Save And Update client===============================//

  SaveorUpdateClient(ClientList) {
    if (this.disableEin && (this.ClientList.isEin == "" || this.ClientList.isEin == null || this.ClientList.isEin == undefined)) {
      this.toasterService.error("Please enter EIN value");
      return
    }
    let Error;
    Error =
    this.ClientList.street != null &&
      this.ClientList.street != undefined &&
      this.ClientList.street != ""
      ? false
      : "Please select street";
  if (Error != false) {
    this.toastrService.error(Error);
    this.saveClientInProgress = false;
    return;
  }
  Error =
    this.ClientList.city != null &&
      this.ClientList.city != undefined &&
      this.ClientList.city != ""
      ? false
      : "Please select city";
  if (Error != false) {
    this.toastrService.error(Error);
    this.saveClientInProgress = false;
    return;
  }
  Error =
    this.ClientList.state != null &&
      this.ClientList.state != undefined &&
      this.ClientList.state != ""
      ? false
      : "Please select state";
  if (Error != false) {
    this.toastrService.error(Error);
    this.saveClientInProgress = false;
    return;
  }
  Error =
    this.ClientList.zipCode != null &&
      this.ClientList.zipCode != undefined &&
      this.ClientList.zipCode != ""
      ? false
      : "Please select zipcode";
  // Regex for US format like (123) 456-7890
const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

// Phone 1 validation
if(this.ClientList.phone1 != null && this.ClientList.phone1 != undefined && this.ClientList.phone1 != '')
 Error =
  this.ClientList.phone1 &&
  phoneRegex.test(this.ClientList.phone1)
    ? false
    : "Please enter a valid Phone 1";


// Phone 2 validation
if(this.ClientList.phone2 != null && this.ClientList.phone2 != undefined && this.ClientList.phone2 != '')
Error =
  this.ClientList.phone2 &&
  phoneRegex.test(this.ClientList.phone2)
    ? false
    : "Please enter a valid Phone 2";


  if (Error != false) {
    this.toastrService.error(Error);
    this.saveClientInProgress = false;
    return;
  }
  Error =
    this.ClientList.county != null &&
      this.ClientList.county != undefined &&
      this.ClientList.county != ""
      ? false
      : "Please select County";
  if (Error != false) {
    this.toastrService.error(Error);
    this.saveClientInProgress = false;
    return;
  }
  Error = this.ClientList.medicaid != null && this.ClientList.medicaid != undefined && this.ClientList.medicaid != "" ? false : " please Fill Medicaid# (PMI) ";
  if(this.ClientList.eventConfirmation){
    Error = this.ClientList.phone1 != null && this.ClientList.phone1 != undefined && this.ClientList.phone1 != '' ? false : "Enter 'Phone 1' to receive event confirmation.";
  }
if(Error != false){
  this.toastrService.error(Error);
  return;
}
    let Clientsave = JSON.parse(JSON.stringify(ClientList));

    Clientsave.dOB = (this.ClientList.dOB != null && this.ClientList.dOB != undefined && this.ClientList.dOB != '' && this.ClientList.dOB != null) ? this.global.getDateTimeString(this.ClientList.dOB) : null;
    Clientsave.weight = (Clientsave.weight != null && Clientsave.weight != undefined && Clientsave.weight != '') ? parseInt(Clientsave.weight) : null;
    Clientsave.isMNChoiceAssessment = null;
    if(ClientList.isMAEligible=='Yes'||ClientList.isMAEligible=='yes'){
      Clientsave.isMAEligible =true;
    }
    else
    Clientsave.isMAEligible = false;
    if(ClientList.spendDown=='Yes'||ClientList.spendDown=='yes'){
      Clientsave.spendDown =true;
    }
    else
    Clientsave.spendDown = false;
    Clientsave.referralDate   = this.global?.getDateTimeString(Clientsave?.referralDate);
    this.ClientService.saveClientData(Clientsave).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (this.ClientList.id == "00000000-0000-0000-0000-000000000000") {
        this.toasterService.success('Client saved SuccessFully');
        this.isEditBoolean = true;
        this.isEditgeneralBoolean= true;

        this.ClientDataForm.disable();
        this.email_formvalidator.disable();
        this.global.viewTabs = true;
        this.isgeneraltabfieldview= true;

        this.ClientEmployeeContact.Id = data;

        this.DocumentListType.Id = data;
        
        this.UtilizationListType.clientId=data?.clientId;
         this.Consultationform.ClientId=data?.clientId;

        this.UtilizationListType.isInsideClient=true;
        this.UtilizationListType.clientName=this.ClientList?.name;
      }
      else {
        this.isFieldEnabled = false;
        this.toasterService.success('Client updated SuccessFully');
      }
      
      this.ClientList.id = data;
      this.ClientEmployeeContact.Id = data;
      this.Consultationform.ClientId = data;
      this.ClientEmployeeDynamicForm.Id = data;
      this.ClientEmployeeRelationship.Id = data;
      this.ClientAuthList.Id = data;
      this.global.clientId = data;
      this.updateClientLanguage();
      this.changevalue = false;
      this.getClientcasemanagerandContactDetails();
      //    this.ClientList.typeofWaiverLid = this.ClientList.typeofWaiverLid[0]; 
      // this.ClientList.typeofWaiverLid =
      // this.ClientList.typeofWaiverLid != null &&
      //   this.ClientList.typeofWaiverLid != 0
      //   ? Math.floor(Number(this.ClientList.typeofWaiverLid))
      //   : null;
      if (this.ClientList.phone1 != null) {
        this.ClientList.phone1 = this.general.reconverPhoneGoogleLib(
          this.ClientList.phone1
        );
        this.ClientList.phone1 =
          this.general.reconverPhoneGoogleLibhttpsave(
            this.ClientList.phone1
          );
      }
      if (this.ClientList.phone2 != null) {
        this.ClientList.phone2 = this.general.reconverPhoneGoogleLib(
          this.ClientList.phone2
        );
        this.ClientList.phone2 =
          this.general.reconverPhoneGoogleLibhttpsave(
            this.ClientList.phone2
          );
      }
    },
      (err: any) => {
        this.toasterService.error(err, "Error");
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);
      }

    )
  }


  /////////////////// BACK CLIENTLIST/////////////
  BackToClientList() {

    this.global.CxCustomerName = null;
    this.global.CxCustomerId = null;
    this.global.viewTabs = false;
    this.isgeneraltabfieldview= false;

    this.back();
  }

  back() {
    this.DataFromList.isEdit = false;
    this.DataFromList.isView = true;
    this.EventToEdit.emit(this.DataFromList);
  }

  changefunction() {
    this.changevalue = true;
  }
  //......................................clientvaluechange.....................................
  clientvaluechange() {
    if (this.changevalue == true) {
    
      document.getElementById("cancelmodal").click();
    } else {

      this.BackToClientList();
    }

  }



  ////////////////////////// Client Medical Record ////////////////////

  Responsiblepartydetails(data: ResponsibleInfoLst) {
    this.Responsibleinfo = JSON.parse(JSON.stringify(data));
  }
  EmergencyContactdetails(data: EmergencyContactInfoLst) {
    this.EmergencyContactinfo = JSON.parse(JSON.stringify(data));
  }
  Caregiversdetails(data: CaregiverInfoLst) {
    this.Caregiversdetailsinfo = JSON.parse(JSON.stringify(data));
  }
  OfficeCaseManagerdetails(data: OfficeCaseManagerInfoLst) {
    this.OfficeCaseManagerinfo = JSON.parse(JSON.stringify(data));
  }
  OfficeCareCoordinatordetails(data: CareCoordinatorInfoLst) {
    this.CareCoordinatorinfo = JSON.parse(JSON.stringify(data));
  }
  Officefmsagencydetails(data: FMSAgencyrInfoLst) {
    this.FMSAgencyinfo = JSON.parse(JSON.stringify(data));
  }
   Officehhaagencydetails(data: HHAgencyInfoLst) {
    this.HHAAgencyinfo = JSON.parse(JSON.stringify(data));
  }

  Qpdetails(data: qpList) {
    data.activeDate = this.datepipe.transform(data?.activeDate, "MM/dd/yyyy")
    this.qpinfo = JSON.parse(JSON.stringify(data));
  }
  QPHistorydetails(data: QPHistoryLst) {
    this.QPHistoryinfo = JSON.parse(JSON.stringify(data));
  }
  BudgetImportData: BudgetImportBO = new BudgetImportBO();
  ServicePlanImportData: ServiceDeliveryPlan = new ServiceDeliveryPlan();
  clientrelation: EmployerEmployeeRelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();


  ////////////////////Client TAB CHANGE////////////////////////

  getTabActiveData(Tabtocall) {
    if (this.ActiveTab == "nav-contacts") {
      this.getClientcasemanagerandContactDetails();

    }
    this.ActiveTab = Tabtocall;
    if (Tabtocall == "nav-notes") {
      this.isNotes = true;
    }
    if (Tabtocall != "nav-notes") {
      this.isNotes = false;
    }

    
    if (Tabtocall == "nav-carecoordinators") {
      this.getclientCareLst();
    }


    if (Tabtocall == "nav-general") {
      this.isFieldEnabled = false;
    }

    if (Tabtocall == "nav-contacts") {
      this.isRelationcontact = true;

    }

    if (Tabtocall == "nav-consultation") {
      this.isconsultationform = true;
    }
    if (Tabtocall != "nav-consultation") {
      this.isconsultationform = false;
    }
    if (Tabtocall != "nav-contacts") {
      this.isEnabledcontact = false;
      this.isRelationcontact = false;

    }

    if (Tabtocall != "nav-relationship") {
      this.isEnabledRelationship = false;
      this.isRelationShip = false;
    }
    if (Tabtocall == "nav-relationship") {
      this.isRelationShip = true;
    }


    if (Tabtocall == "nav-relationshiptaxpercent") {
      this.isRelationShipTaxPercent = true;
      this.getrelationtaxpercentDataList();
      this.GetClientEmployeeRelationshipdropdown();
    }

    if (Tabtocall != "nav-authorization") {

      this.isAuthView = false;
    }
    if (Tabtocall == "nav-authorization") {
      this.isAuthView = true;
    }

    if (Tabtocall != "nav-documents") {
      this.parentToOnboard.docToOnboarding = false
      this.isdynamicFormcontact = false
    }
    if (Tabtocall == "nav-documents") {
      this.parentToOnboard.docToOnboarding = true;
      this.parentToOnboard.clientid = this.ClientList.id;
    }

    // if (Tabtocall == "nav-budget") {
    //   this.BudgetImportData.clientId = this.global.clientId;

    // }
    if (Tabtocall == "nav-serviceplan") {
      this.ServicePlanImportData.clientId = this.global.clientId;

    }
    if (Tabtocall == "nav-purchase") {
      this.purchaseemit = true
      this.emitToPurchase();
    }
    if (Tabtocall != "nav-purchase") {
      this.purchaseemit = false
    }
    if (Tabtocall == "nav-documents") {
      this.DocumentListbool = true;
    }
    if (Tabtocall != "documents") {
      this.DocumentListbool = false;
    }
    if (Tabtocall == "nav-utilization") {
      this.isUtilization=true;
    }
    if (Tabtocall != "nav-utilization") {
      this.isUtilization=false;
    }
    // if(Tabtocall == "nav-csengagement"){
    //   this.csfilter = true
    // }
  }

  /////////////////// EMIT FOR PURCHASE ///////////////////
  purchaseemit = false
  emitToPurchase() {
    this.purchaseEmitBo.clientToPurchase = true;
    this.purchaseEmitBo.clientid = this.ClientList.id
    this.purchaseEmitBo.clientName = this.ClientList.name

  }

  /////////////////// EMIT FOR PURCHASE ///////////////////
  dataEmitFromCDCSPlan(event) {
    this.BudgetImportData.edit = false;
  }
  dataemitBudgetimport(event) {
    this.BudgetImportData.edit = false;
    this.BudgetImportData.clientId = null;
  }
  dataemitServiceimport(event) {
    this.ServicePlanImportData.edit = false;
    this.ServicePlanImportData.clientId = null;
  }
  ClientEmployeeDynamicForm: ClientEmployeeDynamicFormBO =
    new ClientEmployeeDynamicFormBO();
  isdynamicFormcontact: boolean = false;
  /////////////////// EMIT FOR DOCUMENT ///////////////////
  parentToOnboard: onBoardingListBO = new onBoardingListBO();
  reDirect() {
    this.parentToOnboard.docToOnboarding = true;

  }


  dataEmitFromOnboard(value) {
    this.parentToOnboard.docToOnboarding = false;
  }


  ////////////////////// CLIENT EIN changefunction ////////////////
  EinChangesFun(val) {

    var name = this.isEinList.filter((f) => f.id == val)[0]?.lovCode;
    if (name == "YES") {
      this.disableEin = true;


    } else {
      this.disableEin = false;
      this.ClientList.isEin = null;
    }
  }


  /////////////////////////// CLIENT SSN ///////////////////////////////////
  closeSsnValidation() {
    document.getElementById("closeClientssnModal").click();
  }

  ssnerr = false
  ClientChangeSSN() {
    if (this.ClientList.ssn != null && this.ClientList.ssn != undefined && this.ClientList.ssn != '') {

      if (this.ClientList.ssn.length != 0 && this.ClientList.ssn.length != 9) {
        this.ssnerr = true
      }
      else {
        this.ssnerr = false
      }
    }
    else {
      this.ssnerr = false
    }
  }

  //.............................................numbersOnly.......................................
  numbersOnly(event) {
    if (!this.global.isdigit(event.key)) {
      event.preventDefault();
    }
  }

  //.............................................keyPress.......................................
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  //.............................................. DOBdatechange..............................................
  DOBdatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length >= 7 && value.substring(2, 3) != '/') {
      this.ClientList.dOB = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4);
    }


  }

  //............................................. CLIENT DOB CHNAGE............................................ 
  onDateChanged(event: IMyDateModel) {
    this.ClientList.dOB = event.formatted;
    var bdate = new Date(event.formatted);
    var today = new Date();
    var bdate = new Date(event.formatted);
    var age = 0;
    if (bdate.getFullYear() >= today.getFullYear()) {
      age = 0
    }
    else {
      var age = today.getFullYear() - bdate.getFullYear();
      var m = today.getMonth() - bdate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < bdate.getDate())) {
        age--;
      }
    }
    this.ClientList.age = age;
    if (this.ClientList.dOB == null || this.ClientList.dOB == undefined || this.ClientList.dOB == '') {
      this.ClientList.age = null;
    }
    this.changevalue = true;
    if(this.ActiveTab == "nav-notes"|| 
      (this.ActiveTab == "nav-contacts" && this.contactfilter == "contacts") ||
      this.ActiveTab == "nav-general"){
    if(this.clientcasemanagerandContactDetail.participantRes){
     if (this.ClientList.age < 18  && this.ClientList.dOB != undefined && this.ClientList.dOB != '') {
        //document.getElementById("openWarningModal").click()
       this.openWarningModal();
      }
    }
    
  }
  }

  //......................................DemographicPhoneFormat....................................
  DemographicPhoneFormat() {
    this.ClientList.phone1 = this.general.converPhoneGoogleLib(this.ClientList.phone1);
    this.ClientList.phone2 = this.general.converPhoneGoogleLib(this.ClientList.phone2);
    this.ClientList.billto_Phone = this.general.converPhoneGoogleLib(this.ClientList.billto_Phone)

  }

  //................................................LOV DROPDOWN .............................................//

  //................................................getGender.................................................
  getGender() {
    let params = new URLSearchParams();
    params.append("listCode", "GENDER");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data:any) => {
      this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');

    })
  }
  //.............................................getRelationStatus..........................................................
  getRelationStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "RELATIONSHIP");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.forEach(element => {
        element.id = element.id.toString();
      });
      this.conatactRelList = data;

    })
  }
  //.............................................getLiveWithStatus..........................................................
  getLiveWithStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "LIVEWITH");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.forEach(element => {
        element.id = element.id.toString();
      });
      // this.conatactLiveWithList = data;
    })
  }
  //.............................................getPhoneCarrierStatus..........................................................
  getPhoneCarrierStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "PHONECARRIER");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.phoneCarrierList = data;
    })
  }

  //.............................................getLanguage..........................................................
  getLanguage() {
    let params = new URLSearchParams();
    params.append("listCode", "Language");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.languageList = data;
    })
  }
  //.............................................getStatus..........................................................
  getStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusList = data;
      if (this.global.clientId == '00000000-0000-0000-0000-000000000000') {
        this.ClientList.statusLid = this.statusList.filter(s => s.lovName == "Active")[0].id;
      }
    })
  }

  //............................................getLocationDropDown.............................................
  getLocationDropDown() {
    this.ClientService.GetLocationDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.getLocationList = data;
      if (this.getLocationList.length > 0) {
        this.ClientList.locationId = (this.ClientList.locationId != null && this.ClientList.locationId != undefined) ? this.ClientList.locationId : this.getLocationList[0]?.Key;
      }
    },
      err => {
      })
  }
  //......................................getPCATYPE..............................................
  getPCATYPE() {
    let params = new URLSearchParams();
    params.append("listCode", "PCATYPE");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.pcaType = data;
      this.pcaType.forEach(element => {
        element.id = element.id;
      });
    })
  }
  //......................................getAssessmentRating..............................................
  getAssessmentRating() {
    let params = new URLSearchParams();
    params.append("listCode", "ASSESSMENTRATING");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.AssessmentRating = data;
      this.AssessmentRating.forEach(element => {
        element.id = element.id
      });
    })
  }
  //..............................................getTypeofWaiver.................................................
  getTypeofWaiver() {
    let params = new URLSearchParams();
    params.append("listCode", "TYPEOFWAIVER");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.TypeofWaiver = data;
      // this.ClientList.typeofWaiverLid.forEach(element => {
      //   element.id = element.id;
      // });
    })

  }
  //.............................................getContactRelationStatus..............................................
  getContactRelationStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "RELATIONSHIP");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.ContactRelationshipList = data;
    })

  }

  //............................................... GetState ......................................//
  getStatesField() {
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;

    });
  }

  //.............................................getPriorityStatus..............................................
  getPriorityStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "PRIORITYSTATUS");
    this.ClientService.getLOV(params).subscribe((data: any) => {
      this.PriorityStatus = data;

    });

  }

  //.............................................getYesOrNoList..............................................
  getYesOrNoList() {
    let params = new URLSearchParams();
    params.append("listCode", "YESORNO");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.isEinList = data;
      this.EinChangesFun(this.ClientList.isEinLid);

    })
  }

  //.............................................ngOnChanges..............................................
  ngOnChanges(changes: SimpleChanges) {
    this.ClientList = this.DataFromList.clientData;
    // this.GetLanguageList();
    if (this.ClientList.userName != null && this.ClientList.userName != undefined && this.ClientList.userName != "") {
      this.ClientList.requiredEVV = true;
    }
    else {
      this.ClientList.requiredEVV = false;
    }
    setTimeout(() => {
      this.ClientList.dOB = (this.DataFromList.clientData.dOB != null && this.DataFromList.clientData.dOB != '' && this.DataFromList.clientData.dOB != undefined) ? this.datepipe.transform(this.DataFromList.clientData.dOB, "MM/dd/yyyy") : null;
      // this.ClientDataForm.controls['dateofBirth'].setValue(this.ClientList.dOB)

    }, 300);
    this.ClientList.assessmentRatingLid = (this.ClientList.assessmentRatingLid != null && this.ClientList.assessmentRatingLid != '' &&
      this.ClientList.assessmentRatingLid != undefined) ? this.ClientList.assessmentRatingLid.toString() : null;
    this.ClientList.typeofWaiverLid = (this.ClientList.typeofWaiverLid != null && this.ClientList.typeofWaiverLid != '' &&
      this.ClientList.typeofWaiverLid != undefined) ? this.ClientList.typeofWaiverLid.toString() : null;
  }


  //////////////////////////////// CREATE CLIENT PORTAL ///////////////////////////////////////////
  sendToPortalBO: SendToPortalBO = new SendToPortalBO();
  ClearingNotes() {
    this.sendToPortalBO.agencyNote = ''
  }

  CreatePoratl() {
    this.sendToPortalBO.clientId = this.ClientList.id;
    this.sendToPortalBO.agencyNote = this.sendToPortalBO.agencyNote;
    this.sendToPortalBO.username = this.sendToPortalBO.username;
    this.sendToPortalBO.statusLid = this.ClientList.statusLid;
    this.sendToPortalBO.password = this.sendToPortalBO.password;
    this.sendToPortalBO.portalLink = this.EnvironmentService.Environments.onboardingUrl + '#/onboarding/client/'
    this.ClientService.SentToClient(this.sendToPortalBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (!this.isPasswordChanged) {
        document.getElementById('PORTALMODAL').click();
      }
      this.toasterService.success("Portal Created Successfully");
      this.NewPassword = null;
      this.ConformPassword = null;
      this.isPasswordChanged = false;
      this.ClientList.loginUserId = data.loginUserId;
      this.ClientList.userName = data.userName;
      this.ClientList.password = data.password;
      this.ClientList.userName != null && this.ClientList.userName != undefined && this.ClientList.userName != "" ? this.ClientList.requiredEVV = true : this.ClientList.requiredEVV = false;
    },
      (err: any) => {
        this.toasterService.error(
          err,
          "Error",
        );
        setTimeout(() => {
          this.toasterService.clear()
        }, 8000);
      }
    )
  }





  // ..............................................RELATION TAX PERCENT......................................................//

  GetClientEmployeeRelationshipdropdown() {
    let params = new URLSearchParams();
    params.append("ClientId", this.ClientList.id);
    this.ClientService.ClientEmployeRelationShipDropDown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.clientemployeenamedropdown = data;



    })
  }

  ModelType: string;
  Createupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.employeremployeerelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();
      this.relationtaxform.reset();
      this.RelationshipId = null
    }
    else {
      this.ModelType = 'edit';
    }

  }

  GetRelationshipdropdown(cliempid) {
    let params = new URLSearchParams();
    params.append("ClientId", cliempid);
    this.ClientService.ClientRelationShipDropDown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.relationdropdown = data;
      this.relationdropdown.forEach(s => {
        this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId = s.Key


      })
      this.GetRelationshipTaxdropdown(this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId);

    })
  }

  GetRelationshipTaxdropdown(relationshipIp) {
    let params = new URLSearchParams();
    params.append("EmployerEmployeeRelationshipId", relationshipIp);
    this.ClientService.ClientRelationShipTaxDropDown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.relationtaxdropdown = data;

    })
  }

  edit(data) {
    this.employeremployeerelationshipTaxPercentBO = JSON.parse(JSON.stringify(data));
    this.employeremployeerelationshipTaxPercentBO.effectiveDate = this.datepipe.transform
      (this.employeremployeerelationshipTaxPercentBO.effectiveDate, "MM/dd/yyyy")
    this.GetRelationshipdropdown(this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId);
    this.RelationshipId = this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId;
    //this.GetRelationshipTaxdropdown(this.employeremployeerelationshipTaxPercentBO.employerEmployeeRelationshipId);
  }

  // ................................................................................................................................

  SaveList: EmployerEmployeeRelationshipTaxPercentBO = new EmployerEmployeeRelationshipTaxPercentBO();
  SaveOrUpdateActivity(type: string) {
    var saveList: EmployerEmployeeRelationshipTaxPercentBO = JSON.parse(JSON.stringify(this.employeremployeerelationshipTaxPercentBO));
    saveList.id = this.employeremployeerelationshipTaxPercentBO.id;
    saveList.effectiveDate = this.global.getDateTimeString(this.employeremployeerelationshipTaxPercentBO.effectiveDate)
    this.ClientService.saveupdaterelationtaxpercent(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {

        this.SaveList.id = data;
        if (this.ModelType == 'new') {

          this.toasterService.success('relationshiptaxpercent  saved successfully!');

          document.getElementById('opentaxpercentModal').click();
          this.getrelationtaxpercentDataList();
        }
        else {
          this.toasterService.success('relationshiptaxpercent updated successfully!');

          document.getElementById('opentaxpercentModal').click();
          this.getrelationtaxpercentDataList();

        }

      }
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err.error, 'Error'), 8000;
      }
    })
  }

  public ContactId: string;
  setDeleteId(value) {
    this.ContactId = value;
    
  }
  DeleteTaxPercent() {

    let param = new URLSearchParams()
    param.append("employerEmpRelTaxPercentId", this.ContactId)
    this.ClientService.deleterelationtaxpercent(param).subscribe((_data: any) => {
      this.toasterService.success("RelationShip Tax-percent deleted successfully!");
      document.getElementById("closeTaxPercentModal").click();
      this.getrelationtaxpercentDataList();

    },
      err => {
        this.toasterService.error(err.error);
      })

  }
  getrelationtaxpercentDataList() {
    this.RelationTaxPercentGridBO.clientId = this.global.clientId;
    this.clienttserivcetax.executetax(this.RelationTaxPercentGridBO);
    let count = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;

    })
  }


  ///////////////////////////////// FILTER FUNCTION ////////////////////////////
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.RelationTaxPercentGridBO.orderColumn = state.sorted[0].name;
        this.RelationTaxPercentGridBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.RelationTaxPercentGridBO.field = state.action.currentFilterObject.field;
      this.RelationTaxPercentGridBO.matchCase = state.action.currentFilterObject.matchCase;
      this.RelationTaxPercentGridBO.operator = state.action.currentFilterObject.operator;
      this.RelationTaxPercentGridBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.RelationTaxPercentGridBO.field = "name";
        this.RelationTaxPercentGridBO.matchCase = false;
        this.RelationTaxPercentGridBO.operator = "startswith";
        this.RelationTaxPercentGridBO.value = "";
      }
    }
    this.getrelationtaxpercentDataList();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Vendor.Pagesize != state.take) {
          this.arraycol[0].vendor.Pagesize = state.take


        }

      }
    }
  }
  public onActionComplete(args) {

    this.RelationTaxPercentGridBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.RelationTaxPercentGridBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  }
  public onActionCompleteCare(args) {
    this.getClientCare.currentpageno =
      this.gridcarecoordinator.pagerModule.pagerObj.currentPage;
    this.getClientCare.pageitem =
      this.gridcarecoordinator.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getClientCare.type = args.columnType;
    }
  }





  // disablePortalBtn = false
  // getPortalCheck() {

  //   if (this.ClientList.id != null && this.ClientList.id != undefined && this.ClientList.id != '00000000-0000-0000-0000-000000000000') {
  //     let params = new URLSearchParams();
  //     params.append("ClientId", this.ClientList.id);
  //     this.ClientService.getportalCreateCheck(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

  //       if (data) {

  //         this.disablePortalBtn = false
  //       } else {

  //         this.disablePortalBtn = true
  //       }
  //     })
  //   }

  // }

  ngAfterContentChecked() {
    this.ClientList.dOB = (this.DataFromList.clientData.dOB != null && this.DataFromList.clientData.dOB != '' && this.DataFromList.clientData.dOB != undefined) ? (this.DataFromList.clientData.dOB) : null;
    // this.ClientDataForm.controls['dateofBirth'].setValue(this.ClientList.dOB);
    this.cdr.detectChanges();
  }




  GetLanguageList() {
    if (this.DataFromList.clientId != null && this.DataFromList.clientId != undefined && this.DataFromList.clientId != '') {
      let clientlanguagelist = [];

      let params = new URLSearchParams();
      params.append("ClientId", this.DataFromList.clientId);

      this.ClientService.ClientLanguageList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {

          clientlanguagelist?.push(element.languageLid)
        });
        this.ClientList.languageLid = clientlanguagelist

      })

    }
  }

  disablelogin: boolean = true;
  //......................................switchchange.....................................
  switchchange() {
    if (this.ClientList.requiredEVV) {
      document.getElementById('PORTALMODAL').click();
    } else {
      document.getElementById('openEvvModal').click();
    }
  }

  //......................................passwordResetFunction.....................................
  passwordResetFunction() {
    if (
      this.ClientList.loginUserId != null &&
      this.ClientList.loginUserId != undefined &&
      this.ClientList.loginUserId != ""
    ) {
      let params = new URLSearchParams();
      params.append("LoginUserId", this.ClientList.loginUserId);
      // params.append("userRole", "CLIENT");
      let url = "api/Client/removeEvvClientCredential?";
      this.ClientService.GetFunctionwithResponseTypeText(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            document.getElementById("openEvvModal").click();
            this.toasterService.success("Access disabled successfully");
            this.sessionLogout();
          },
          (err: any) => {
            this.toasterService.error("Kindly refresh the application!");
          }
        );
    }
  }

  //......................................sessionLogout.....................................
  sessionLogout() {
    let params = new URLSearchParams();
    params.append("RefreshTokenString", this.global.refreshTokenString);
    params.append("UserId", this.DataFromList.clientId.toString());
    params.append("userRole", "CLIENT");
    params.append("UserName", this.ClientList.userName);
    params.append("AgencyCode", this.global.agencyCode);
    let url = "api/Auth/sessionLogout?";
    this.ClientService
      .GetFunctionwithResponseTypeText(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ClientList.userName = null;
          this.ClientList.password = null;
        },
        (err: any) => {
          this.toasterService.error(err, "error");
        }
      );
  }


  //......................................dataEmitfromChild.....................................

  EditOptions: EditDetailsAuthorization = new EditDetailsAuthorization();
  authTypeFilter: AuthorizationFilterBo = new AuthorizationFilterBo();
  EditAuthorization: boolean = false;
  dataEmitfromChild(event: EditDetailsAuthorization) {
    this.EditAuthorization = event.isEdit;
    this.EditOptions = event;
  }

  ngOnDestroy() {    
    this.global.viewTabs = false;
    this.isgeneraltabfieldview= false;

    this.global.clientId = null;
  }
  isPasswordChanged: boolean = false
  changePassword() {
    if (this.NewPassword != this.ConformPassword) {
      this.toasterService.error("The password and confirmation password do not match.")
    }
    else {
      this.sendToPortalBO.password = this.NewPassword;
      this.isPasswordChanged = true;
      this.CreatePoratl();
      document.getElementById('PasswordChangeModal').click();
    }
  }
  updateClientLanguage() {
    let langmappingsaveBO: LanguageMappingSaveBO = new LanguageMappingSaveBO();
    langmappingsaveBO.clientId = this.global.clientId;
    langmappingsaveBO.employeeId = null;
    if (this.selectedLanguages.length <= 0) {
      this.selectedLanguages = [];
    }
    this.selectedLanguages.forEach((element) => {
      langmappingsaveBO.languageLids.push(element);
    });
    let url = "api/Language/SaveClientorEmployeeLanguage";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(langmappingsaveBO, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.getClientLanguages();
        },
        (err: any) => {
          this.saveorUpdateLanguageError = "";
          this.saveorUpdateLanguageError = err;
          if (this.saveorUpdateLanguageError != "") {
            setTimeout(
              function () {
                this.saveorUpdateLanguageError = "";
              }.bind(this),
              8000
            );
          }
        }
      );
  }

  getClientLanguages() {
    if (this.ClientEmployeeContact.Id != "" && this.ClientEmployeeContact.Id != null && this.ClientEmployeeContact.Id! + undefined && this.ClientEmployeeContact.Id != "00000000-0000-0000-0000-000000000000") {
      let params = new URLSearchParams();
      params.append("clientId", this.ClientEmployeeContact.Id);
      let url = "api/Language/GetClientLanguageList?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            let val: any = [];
            data.forEach((element) => {
              let valtemp = element.languageLid.toString();
              val.push(valtemp);
            });
            this.selectedLanguages = val;
          },
          (err: any) => {
            this.toasterService.error(err);
          }
        );
    } else {
      this.selectedLanguages = [];
    }
  }


  //......................................getClientcasemanagerandContactDetails.....................................
  getClientcasemanagerandContactDetails() {
    let myparams = new URLSearchParams();
    myparams.append("clientId", this.global.clientId.toString());
    let url = "api/Client/getClientSummary?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).subscribe(
      (data) => {
        this.clientcasemanagerandContactDetail = data;
        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) => (t.phone = this.general.converPhoneGoogleLib(t.phone))
        );

        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) => (t.fax = this.general.converPhoneGoogleLib(t.fax))
        );
        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) =>
            (t.alternateFax = this.general.converPhoneGoogleLib(t.alternateFax))
        );

        // this.clientcasemanagerandContactDetail?.qps?.map(
        //   (qps) => (qps.phone1 = this.general.converPhoneGoogleLib(qps.phone1))
        // );

        // this.clientcasemanagerandContactDetail?.qps?.map(
        //   (qps) => (qps.phone2 = this.general.converPhoneGoogleLib(qps.phone2))
        // );
        this.clientcasemanagerandContactDetail?.emergencyContacts?.map(
          (p) =>
            (p.phoneNumber = this.general.converPhoneGoogleLib(p.phoneNumber))
        );
        this.clientcasemanagerandContactDetail?.responsiblePartyContacts?.map(
          (p) =>
            (p.phoneNumber = this.general.converPhoneGoogleLib(p.phoneNumber))
        );
        // this.clientcasemanagerandContactDetail?.interpreter?.map(
        //   (p) =>
        //     (p.phoneNumber = this.general.converPhoneGoogleLib(p.phoneNumber))
        // );

        this.clientcasemanagerandContactDetail?.careCoordinators.map(
          (CC) =>
            (CC.phoneNumber = this.general.converPhoneGoogleLib(CC.phoneNumber))
        );

        this.clientcasemanagerandContactDetail?.careCoordinators.map(
          (CC) =>
          (CC.alternateFax = this.general.converPhoneGoogleLib(
            CC.alternateFax
          ))
        );

        this.clientcasemanagerandContactDetail?.careCoordinators.map(
          (CC) => (CC.fax = this.general.converPhoneGoogleLib(CC.fax))
        );
        this.clientcasemanagerandContactDetail?.fmsAgency.map(
          (CC) =>
            (CC.phoneNumber = this.general.converPhoneGoogleLib(CC.phoneNumber))
        );

        this.clientcasemanagerandContactDetail?.fmsAgency.map(
          (CC) =>
          (CC.fax = this.general.converPhoneGoogleLib(
            CC.fax
          ))
        );
              this.clientcasemanagerandContactDetail?.hhAgency.map(
          (CC) =>
            (CC.phoneNumber = this.general.converPhoneGoogleLib(CC.phoneNumber))
        );

        this.clientcasemanagerandContactDetail?.hhAgency.map(
          (CC) =>
          (CC.fax = this.general.converPhoneGoogleLib(
            CC.fax
          ))
        );

        // this.clientcasemanagerandContactDetail?.caregivers?.map(
        //   (t) => {
        //     (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"));
        //     (t.phone1 = (t.phone1 != null) ? this.general.converPhoneGoogleLib(t.phone1) : t.phone1)
        //   }
        // );
        // this.clientcasemanagerandContactDetail?.qps?.map(
        //   (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        // );
        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );
        this.clientcasemanagerandContactDetail?.careCoordinators?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );

        this.clientcasemanagerandContactDetail?.employeeClientMappings?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );
          this.clientcasemanagerandContactDetail?.fmsAgency?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );
        this.clientcasemanagerandContactDetail?.hhAgency?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );

        // this.clientcasemanagerandContactDetail?.housecoordinator?.map(
        //   (t) => {
        //     (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"));
        //     (t.phoneNumber = (t.phoneNumber != null) ? this.general.converPhoneGoogleLib(t.phoneNumber) : t.phone1);
        //     (t.fax = (t.fax != null) ? this.general.converPhoneGoogleLib(t.fax) : t.fax);
        //     (t.alternate_Fax = (t.alternate_Fax != null) ? this.general.converPhoneGoogleLib(t.alternate_Fax) : t.alternate_Fax)
        //   }
        // );

        this.clientcasemanagerandContactDetail?.qps?.forEach((a) => {
          a.address =
            (a.street != null ? a.street : "") +
            " " +
            (a.apt != null ? a.apt : "") +
            " " +
            (a.city != null ? a.city : "") +
            " " +
            (a.steet != null ? a.steet : "") +
            " " +
            (a.zipcode != null ? a.zipcode : "");
        });
        //  this.clientcasemanagerandContactDetail.emergencycontactBO.map(t=> t.emergencyalternatephone = this.general.converPhoneGoogleLib(t.emergencyalternatephone));
        if(this.ActiveTab == "nav-notes"|| 
          // this.ActiveTab == "nav-contacts" ||
          // this.ActiveTab == "nav-contacts" ||
          (this.ActiveTab == "nav-contacts" && this.contactfilter == "contacts") ||
          this.ActiveTab == "nav-general"){
             let delay = 500;
          if(this.clientcasemanagerandContactDetail.respartypopup){
              
          if (this.ClientList.age < 18  && this.ClientList.dOB != undefined && this.ClientList.dOB != '') {
this.openWarningModal();
    
            
          }
           
          
        }
      }
      
      if (this.clientcasemanagerandContactDetail.isMAEligible === false) {
        this.openEligibilityWarningModal();

}
        // if(data?.respartypopup){
        //   const modalElement = document.getElementById('warningModal');
        //   if (modalElement) {
        //     const modal = new bootstrap.Modal(modalElement);
        //     modal.show();
        //   }
        // }
        
      },
      (err) => { }
    );

  }

  colors = [
    { label: 'Red', value: 'red' },

    { label: 'Yellow', value: 'yellow' },
    { label: 'Green', value: 'green' },
    { label: 'Blue', value: 'blue' }
  ];

  selectedColor: any
  
  //......................................openemitMonitorModal.....................................
  openemitMonitorModal() {
    console.log(this.ClientList.isMonitor, "this.ClientList.isMonito");

    this.EmitMonitorList.isClient = true
    this.EmitMonitorList.clientId = this.ClientList?.id
    if (this.ClientList.isMonitor == true) {
      document.getElementById('openemitmonitormodal').click()
    }
    else {
      document.getElementById('multipledeletemonitor').click();
      this.destroymonitor();
    }
  }

// openEligibilityWarningModal() {
//   setTimeout(() => {
//     const modalElement = document.getElementById('eligibilityWarningModal');
//     if (modalElement) {
//       const modal = new bootstrap.Modal(modalElement);
//       modal.show();
//     }
//   }, 500); // 500ms delay


// }
closeEligibilityModal() {
  const modalEl = document.getElementById('eligibilityWarningModal');
  const modal = bootstrap.Modal.getInstance(modalEl);
  modal?.hide();
  
  // Remove backdrop manually
  const backdrop = document.querySelector('.modal-backdrop');
  backdrop?.remove();
  
  // Remove modal-open class from body
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}
// closeEligibilityModal() {
//   const modalElement = document.getElementById('eligibilityWarningModal');

//   if (modalElement) {
//     const modalInstance = bootstrap.Modal.getInstance(modalElement);
//     modalInstance?.hide();
//   }

//   // Force cleanup
//   document.body.classList.remove('modal-open');
//   document.body.style.overflow = '';  // Reset overflow
//   document.body.style.paddingRight = '';  // Reset padding

//   // Remove backdrop
//   const backdrops = document.getElementsByClassName('modal-backdrop');
//   while (backdrops.length > 0) {
//     backdrops[0].remove();
//   }
// }
closeWarningModal() {
  const modalElement = document.getElementById('warningModal');

  if (modalElement) {
    const modalInstance = bootstrap.Modal.getInstance(modalElement);
    modalInstance?.hide();
  }

  // Force cleanup
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';  // Reset overflow
  document.body.style.paddingRight = '';  // Reset padding

  // Remove backdrop
  const backdrops = document.getElementsByClassName('modal-backdrop');
  while (backdrops.length > 0) {
    backdrops[0].remove();
  }
}


  //......................................DataFromClientEmployeeMonitor.....................................
  DataFromClientEmployeeMonitor(data) {

    this.ClientList.isMonitor = data.isAdddedClientMonitor

  }
  //......................................destroymonitor.....................................
  destroymonitor() {
    this.EmitMonitorList = new EmitMonitorList();

  }
  // openemitMonitorModal(data) {
  //   console.log(data, "ClientList.isMonitor");
  //   if (data) {
  //     // let val = this.monitorList.filter(m=> m.monitorId == this.ClientList.monitorId )[0]?.colorName;
  //     // this.selectedColor={
  //     //   label: val,
  //     //   value:val
  //     // }
  //     document.getElementById('openmonitorListModal').click();

  //   }
  //   else {
  //     if (this.ClientList.monitorId != null && this.ClientList.monitorId != "00000000-0000-0000-0000-000000000000") {
  //       let saveListitems: CLientMonitorBO = new CLientMonitorBO()
  //       //= JSON.parse(JSON.stringify(this.saveListFields));

  //       saveListitems.clientId = this.ClientList.id;
  //       saveListitems.monitorId = "00000000-0000-0000-0000-000000000000"
  //       console.log(saveListitems, "saveListitems=======");

  //       let url = "api/Client/SaveClientColorNote"
  //       // saveListitems.id = this.saveListFields.id;
  //       // if (this.saveListFields.isAvailableToAgency == null || this.saveListFields.isAvailableToAgency == undefined || this.saveListFields.isAvailableToAgency == false) {
  //       //   saveListitems.isAvailableToAgency = false;
  //       // }
  //       this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveListitems, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //         if (data) {
  //           //this.ClientList.monitorId=null

  //           //this.toasterService.success('Monitor Removed successfully!');
  //           setTimeout(() => {
  //             this.toasterService.clear();
  //           }, 8000);


  //         }
  //       }, (err: any) => {
  //         if (err) {
  //           this.toasterService.error(err, 'Error'), 8000;
  //         }
  //       })
  //     }

  //   }
  // }

  //.........................................SaveOrUpdateList.............................................
  Savemonitor() {
    let saveListitems: CLientMonitorBO = new CLientMonitorBO()
    //= JSON.parse(JSON.stringify(this.saveListFields));

    saveListitems.clientId = this.ClientList.id;
    saveListitems.monitorId = this.monitorList.filter(element => element.label == this.selectedColor.label)[0].monitorId;;
    console.log(saveListitems, "saveListitems=======");

    let url = "api/Client/SaveClientColorNote"
    // saveListitems.id = this.saveListFields.id;
    // if (this.saveListFields.isAvailableToAgency == null || this.saveListFields.isAvailableToAgency == undefined || this.saveListFields.isAvailableToAgency == false) {
    //   saveListitems.isAvailableToAgency = false;
    // }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveListitems, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        this.ClientList.monitorId = data

        this.toasterService.success('Monitor Saved successfully!');
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);

        document.getElementById('openmonitorListModal').click();

      }
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }

  monitorList: any = []
  getMonitorList() {
    let myparams = new URLSearchParams();
    //  myparams.append("clientId", this.global.clientId.toString());
    let url = "api/Client/GetMonitors?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).subscribe(
      (data) => {
        this.monitorList = data;
        this.monitorList.forEach(element => {
          element.label = element.colorName
          element.value = element.colorName
        });
        //  colors = [
        //   { label: 'Red', value: 'red' },

        //   { label: 'Yellow', value: 'yellow' },
        //   { label: 'Green', value: 'green' },
        //   { label: 'Blue', value: 'blue' }
        // ];
      })
  }


  clearlist(type: string) {
    if (this.ClientList.monitorId == null || this.ClientList.monitorId == "00000000-0000-0000-0000-000000000000" || this.ClientList.monitorId == "") {
      this.ClientList.isMonitor = false;
      this.selectedColor = { label: null, value: null }
    }

    document.getElementById('openmonitorListModal').click();
  }

     

      dataEmitFromCertificate(event) {
        this.Editcert = event.isEdit;
        this.EditCertificateoption = event;
      }
      //......................................dataEmitfromChildSOC.....................................
      dataEmitfromChildSOC(event: EditSOCDetails) {
        console.log(event,"event")
        this.EditSOC = event.isEdit;
        this.EditSOCOptions = event;
      }
      //......................................EventfromSOCEdit.....................................
      EventfromSOCEdit(event: EditSOCDetails) {
        this.EditSOC = event.isEdit;
        this.EditSOCOptions = event;
      }  
  //......................................deleteMonitoroff.....................................
  deleteMonitoroff() {
    let params = new URLSearchParams();
    params.append("Clientid", this.ClientList.id?.toString());
    let url = "api/Client/changeClientMonitorByClientId?";
    this.CommonAPI.QueryStringWithResponseTypeText("", params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          document.getElementById("multipledeletemonitor").click();
          this.destroymonitor();
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }

  getCaseManagerDropdown() {
    this.assignCase = new AssignCaseManager();
    let url = "api/ClientCaseManagerRelationship/GetCaseManagerDropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.CaseManagerDropdownList = data;
          this.CaseManagerDropdownList.forEach(element => {
            element.Key = element.Key?.toString();
            element.Value = element.Value?.toString();
          });

        },
        (err: any) => {
          this.toasterService.error(err);
        }
      );
  }

  getclientCaseLst() {
    if (this.CaseStatus == null) {
      this.getClientCasemanager.statusLid = "00000000-0000-0000-0000-000000000000";
    }
    this.getClientCasemanager.clientId = this.global.clientId;
    this.getClientCasemanager.statusLid = this.CaseStatus;
    let url = "api/ClientCaseManagerRelationship/GetCaseManagerRelationshipList";
    let responseData = {
      result: "result",
      count: "count",
    };

    this.CommonAPI.outputValues(url, this.getClientCasemanager, responseData, "");
    this.datacase.pipe(takeUntil(this.onDestroy$)).subscribe((datacase: any) => {

      this.caseLst = datacase.result;
      this.caseLst.forEach((c) => {
        c.fax != null
          ? this.general.reconverPhoneGoogleLibhttpsave(c.fax)
          : null;
        c.alternateFax != null
          ? this.general.reconverPhoneGoogleLibhttpsave(c.alternateFax)
          : null;
        c.phone != null
          ? this.general.reconverPhoneGoogleLibhttpsave(c.phone)
          : null;
      });
    },
      (err: any) => {
        this.toasterService.error(err);
      }
    );
  }



  getStatusforCase() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {

      this.StatusLst = data;
      this.StatusLst.push({ lovVaule: 'All', lovName: "All" });
      this.CaseStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.fmsStatus=this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
    },
      (err: any) => {
        this.toasterService.error(err);
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);
      }
    );

  }


  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == 'ActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignCase.activeDate = val1;
        }
      }

      if (name == 'InActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignCase.inActiveDate = val1;
        }

      }

      if (name == 'CareActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignCare.activeDate = val1;
        }
      }
      if (name == 'CareInActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignCare.inActiveDate = val1;
        }
      }
        if (name == 'fmsagencyActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignfms.activeDate = val1;
        }
      }
      if (name == 'fmsagencyInActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignfms.inActiveDate = val1;
        }
      }
        if (name == 'hhaagencyActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignhha.activeDate = val1;
        }
      }
      if (name == 'hhaagencyInActiveDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.assignhha.inActiveDate = val1;
        }
      }

    }
    if (type == "datechanged") {
      if (name == 'ActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignCase.activeDate  = val1;
        }

      }

      if (name == 'InActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignCase.inActiveDate = val1;
        }
      }

      if (name == 'CareActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignCare.activeDate = val1;
        }
      }
      if (name == 'CareInActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignCare.inActiveDate = val1;
        }
      }
        if (name == 'fmsagencyActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignfms.activeDate = val1;
        }
      }
      if (name == 'fmsagencyInActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignfms.inActiveDate = val1;
        }
      }
         if (name == 'hhaagencyActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignhha.activeDate = val1;
        }
      }
      if (name == 'hhaagencyInActiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.assignhha.inActiveDate = val1;
        }
      }
    }
  }



  closecasemanager() {
    document.getElementById("casemanager").click();
    
  }
  closecase() {
    document.getElementById("Caseopen").click();
    
  }
  evenfromcase(event) {
    this.saveclientcase.caseManagerId = event;
    this.saveclientcase.clientId = this.global.clientId;
    this.saveclientcase.activeDate = this.assignCase.activeDate;
    this.saveclientcase.inActiveDate = this.assignCase.inActiveDate;
    let url =
      "api/ClientCaseManagerRelationship/SaveClientCaseManagerRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.saveclientcase, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.caseenable = false;
          document.getElementById("Caseopen").click();
          this.getclientCaseLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }

  AssignCase() {
    var saveList: AssignCaseManager = JSON.parse(JSON.stringify(this.assignCase));
    saveList.activeDate = (saveList?.activeDate != null && saveList?.activeDate != undefined
      && saveList?.activeDate != "") ? this.global.getDateTimeString(saveList.activeDate) : null;
    saveList.inActiveDate = (saveList?.inActiveDate != null && saveList?.inActiveDate != undefined
      && saveList?.inActiveDate != "") ? this.global.getDateTimeString(saveList?.inActiveDate) : null;
    saveList.caseManagerId = saveList.caseManagerId
    saveList.clientId = this.global.clientId;

    if (saveList.activeDate != null && saveList.inActiveDate != null) {
      if (new Date(saveList.activeDate).getTime() > new Date(saveList.inActiveDate).getTime()) {
        this.toasterService.error("End Date should greater than Start Date");
        this.assignCase.inActiveDate = ''
        return;
      }
    }
    let url =
      "api/ClientCaseManagerRelationship/SaveClientCaseManagerRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.caseenable = false;
          if (this.assignCase.id != undefined && this.assignCase.id != null) {
            this.toasterService.success('Case Manager updated successfully!');

          } else {
            this.toasterService.success('Case Manager Assigned successfully!');

            this.CaseStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;


          }
          document.getElementById("Caseopen").click();
          this.getclientCaseLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }
  public dataStateChangeCasemanager(state): void {
    let val = state.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getClientCasemanager.orderColumn = "CaseManagerName";
        this.getClientCasemanager.orderType = "asc";
      }
    }

    if (val == "filtering" && state.action.action != "clearFilter") {
      this.getClientCasemanager.field = state.action.currentFilterObject.field;
      this.getClientCasemanager.matchCase =
        state.action.currentFilterObject.matchCase;
      this.getClientCasemanager.operator =
        state.action.currentFilterObject.operator;
      this.getClientCasemanager.value = state.action.currentFilterObject.value;
    } else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.getClientCasemanager.field = "CaseManagerName";
        this.getClientCasemanager.matchCase = false;
        this.getClientCasemanager.operator = "contains";
        this.getClientCasemanager.value = "";
        this.getClientCasemanager.type = "string";
        this.getClientCasemanager.clientId = this.global.clientId;
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Client_Casemanager.Pagesize != state.take) {
          this.arraycol[0].Client_Casemanager.Pagesize = state.take;
          // this.SaveColumnwidth();
          // }
        }
      }
    }
    this.getclientCaseLst();

  }


  public onActionCompleteCasemanager(args) {
    this.getClientCasemanager.currentpageno =
      this.gridcasemanager.pagerModule.pagerObj.currentPage;
    this.getClientCasemanager.pageitem =
      this.gridcasemanager.pagerModule.pagerObj.pageSize;

    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getClientCasemanager.type = args.columnType;
    }
  }


  deleteCase() {
    let params = new URLSearchParams();
    params.append("Id", this.deletecaseId.toString());
    let url =
      "api/ClientCaseManagerRelationship/DeleteClientCaseManagerRelationship?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success(
            "Client Case Manager deleted successfully!"
          );
          document.getElementById("deletecasemanger").click();
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
          this.getClientcasemanagerandContactDetails();
          this.getclientCaseLst();
          document.getElementById("deletecasemanger").click();
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }


  editcasemanager(data) {
    this.assignCase = data
    this.assignCase.caseManagerId = data.caseManagerId?.toString()
    this.assignCase.activeDate = this.datepipe.transform(data?.activeDate, 'MM/dd/yyyy')
    this.assignCase.inActiveDate = this.datepipe.transform(data?.inActiveDate, 'MM/dd/yyyy')

  }


  //......................................closecarecoordinator.....................................
  closecarecoordinator() {
    document.getElementById("Careopen").click();

  }
    closefmsagency() {
    document.getElementById("FMSagencyopen").click();

  }
  closehhaagency() {
    document.getElementById("HHAagencyopen").click();

  }
  //......................................onResize.....................................
  onResize(args) {
    if (this.ColumnArray_care != undefined && this.ColumnArray_care != null) {
      const column = this.gridcarecoordinator.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray_care.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }



  //......................................AssignCare.....................................
  AssignCare() {
    var saveList: AssignCareCoordinator = JSON.parse(JSON.stringify(this.assignCare));
    saveList.activeDate = (saveList?.activeDate != null && saveList?.activeDate != undefined
      && saveList?.activeDate != "") ? this.global.getDateTimeString(saveList.activeDate) : null;
    saveList.inActiveDate = (saveList?.inActiveDate != null && saveList?.inActiveDate != undefined
      && saveList?.inActiveDate != "") ? this.global.getDateTimeString(saveList?.inActiveDate) : null;
    saveList.careCoordinatorId = (saveList.careCoordinatorId?.toString())
    saveList.clientId = this.global.clientId;
    if (saveList.activeDate != null && saveList.inActiveDate != null) {
      if (new Date(saveList.activeDate).getTime() > new Date(saveList.inActiveDate).getTime()) {
        this.toastrService.error("End Date should greater than Start Date");
        this.assignCare.inActiveDate = ''
        return;
      }
    }
    let url =
      "api/ClientCareCoordinatorRelationship/SaveClientCoordinatorRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.careenable = false;

          if (this.assignCare.id != undefined && this.assignCare.id != null ) {
            this.toastrService.success('Care Coordinator updated successfully!');

          } else {
            this.toastrService.success('Care Coordinator Assigned successfully!');
            this.CareStatus = this.StatusFilterLst?.filter(ele => ele.lovCode == "ACTIVE")[0].id;

          }
          document.getElementById("Careopen").click();
          this.getclientCareLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );


  }
    //......................................AssignCare.....................................
  AssignFMSAgency() {
    var saveList: AssignFMSAgency = JSON.parse(JSON.stringify(this.assignfms));
    saveList.activeDate = (saveList?.activeDate != null && saveList?.activeDate != undefined
      && saveList?.activeDate != "") ? this.global.getDateTimeString(saveList.activeDate) : null;
    saveList.inActiveDate = (saveList?.inActiveDate != null && saveList?.inActiveDate != undefined
      && saveList?.inActiveDate != "") ? this.global.getDateTimeString(saveList?.inActiveDate) : null;
    saveList.fmsagencyId = (saveList.fmsagencyId?.toString())
    saveList.clientId = this.global.clientId;
    if (saveList.activeDate != null && saveList.inActiveDate != null) {
      if (new Date(saveList.activeDate).getTime() > new Date(saveList.inActiveDate).getTime()) {
        this.toastrService.error("End Date should greater than Start Date");
        this.assignfms.inActiveDate = ''
        return;
      }
    }
    let url =
      "api/ClientFMSAgencyRelationship/SaveClientFMSAgencyRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.fmsagencyenable = false;

          if (this.assignfms.id != undefined && this.assignfms.id != null ) {
            this.toastrService.success('FMS Agency updated successfully!');

          } else {
            this.toastrService.success('FMS Agency  Assigned successfully!');
            this.fmsStatus = this.StatusFilterLst?.filter(ele => ele.lovCode == "ACTIVE")[0].id;

          }
          document.getElementById("FMSagencyopen").click();
          this.getclientfmsLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );


  }
    AssignHHAAgency() {
    var saveList: AssignHHAAgency = JSON.parse(JSON.stringify(this.assignhha));
    saveList.activeDate = (saveList?.activeDate != null && saveList?.activeDate != undefined
      && saveList?.activeDate != "") ? this.global.getDateTimeString(saveList.activeDate) : null;
    saveList.inActiveDate = (saveList?.inActiveDate != null && saveList?.inActiveDate != undefined
      && saveList?.inActiveDate != "") ? this.global.getDateTimeString(saveList?.inActiveDate) : null;
    saveList.hhAgencyId = (saveList.hhAgencyId?.toString())
    saveList.clientId = this.global.clientId;
    if (saveList.activeDate != null && saveList.inActiveDate != null) {
      if (new Date(saveList.activeDate).getTime() > new Date(saveList.inActiveDate).getTime()) {
        this.toastrService.error("End Date should greater than Start Date");
        this.assignhha.inActiveDate = ''
        return;
      }
    }
    let url =
      "api/ClientHHAgencyRelationship/SaveClientHHAgencyRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.hhaagencyenable = false;

          if (this.assignhha.id != undefined && this.assignhha.id != null ) {
            this.toastrService.success('Home Health Agency updated successfully!');

          } else {
            this.toastrService.success('Home Health Agency  Assigned successfully!');
            this.hhaStatus = this.StatusFilterLst?.filter(ele => ele.lovCode == "ACTIVE")[0].id;

          }
          document.getElementById("HHAagencyopen").click();
          this.getclienthhaLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );


  }
  //.................................................getStatusforFilter........................................................
  getStatusforFilter() {
        let url = 'api/LOV/getLovDropDown?'
        let params = new URLSearchParams();
        params.append("ListCode", "STATUS");
        this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {
    
          this.StatusFilterLst = data;
          this.StatusFilterLst.push({ lovVaule: 'All', lovName: "All" });
          this.CareStatus = this.StatusFilterLst.filter(st => st.lovCode == "ACTIVE")[0].id;

        },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }
  //......................................editcaremanager.....................................
  editcaremanager(data) {
    this.assignCare = data
    this.assignCare.careCoordinatorId = data?.careCoordinatorId?.toString();
    this.assignCare.activeDate = this.datepipe.transform(data?.activeDate, 'MM/dd/yyyy')
    this.assignCare.inActiveDate = this.datepipe.transform(data?.inActiveDate, 'MM/dd/yyyy')
  }

   editfmsmanager(data) {
    this.assignfms = data
    this.assignfms.fmsagencyId = data?.fmsAgencyId?.toString();
    this.assignfms.activeDate = this.datepipe.transform(data?.activeDate, 'MM/dd/yyyy')
    this.assignfms.inActiveDate = this.datepipe.transform(data?.inActiveDate, 'MM/dd/yyyy')
  }
    edithhamanager(data) {
    this.assignhha = data
    this.assignhha.hhAgencyId = data?.hhAgencyId?.toString();
    this.assignhha.activeDate = this.datepipe.transform(data?.activeDate, 'MM/dd/yyyy')
    this.assignhha.inActiveDate = this.datepipe.transform(data?.inActiveDate, 'MM/dd/yyyy')
  }

  //......................................dataStateChangeCare.....................................
  public dataStateChangeCare(state): void {
    let val = state.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getClientCare.orderColumn = "CaseManagerName";
        this.getClientCare.orderType = "asc";
      }
    }

    if (val == "filtering" && state.action.action != "clearFilter") {
      this.getClientCare.field = state.action.currentFilterObject.field;
      this.getClientCare.matchCase = state.action.currentFilterObject.matchCase;
      this.getClientCare.operator = state.action.currentFilterObject.operator;
      this.getClientCare.value = state.action.currentFilterObject.value;
    } else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.getClientCare.field = "CaseManagerName";
        this.getClientCare.matchCase = false;
        this.getClientCare.operator = "contains";
        this.getClientCare.value = "";
        this.getClientCare.type = "string";
        this.getClientCare.clientId = this.global.clientId;
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Client_Carecoordinator.Pagesize != state.take) {
            this.arraycol[0].Client_Carecoordinator.Pagesize = state.take;
            // this.SaveColumnwidth();
          }
        }
      }
    }
    this.getclientCareLst();
  }

  //......................................deleteCeare.....................................
  deleteCeare() {
    let params = new URLSearchParams();
    params.append("Id", this.deletecareId.toString());
    let url =
      "api/ClientCareCoordinatorRelationship/DeleteClientCoordinatorRelationship?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success(
            "Client Care Coordinator deleted successfully!"
          );
          document.getElementById("deletecarecoordinator").click();
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getClientcasemanagerandContactDetails();
          this.getclientCareLst();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
  deletefmsagency() {
    let params = new URLSearchParams();
    params.append("Id", this.deletefmsId.toString());
    let url =
      "api/ClientFMSAgencyRelationship/DeleteClientFMSAgencyRelationship?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success(
            "Client FMS Agency deleted successfully!"
          );
          document.getElementById("deletefmsagency").click();
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getClientcasemanagerandContactDetails();
          this.getclientfmsLst();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
   deletehhaagency() {
    let params = new URLSearchParams();
    params.append("Id", this.deletehhaId.toString());
    let url =
      "api/ClientHHAgencyRelationship/DeleteClientHHAgencyRelationship?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toastrService.success(
            "Client HHA Agency deleted successfully!"
          );
          document.getElementById("deletehhaagency").click();
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getClientcasemanagerandContactDetails();
          this.getclienthhaLst();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }

  //......................................getclientCareLst.....................................
  getclientCareLst() {
    this.getClientCare.clientId = this.global.clientId;
    this.getClientCare.statusLid = (this.CareStatus != 0) ? (this.CareStatus?.toString()) : null;
    this.CCESCare.outputValuesCareCoordinator(this.getClientCare);
    this.datacare.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.carecoLst = data.result;

        this.carecoLst.forEach((c) => {
          c.fax != null
            ? this.general.reconverPhoneGoogleLibhttpsave(c.fax)
            : null;
          c.alternateFax != null
            ? this.general.reconverPhoneGoogleLibhttpsave(c.alternateFax)
            : null;
          c.phoneNumber != null
            ? this.general.reconverPhoneGoogleLibhttpsave(c.phoneNumber)
            : null;
        });
      },
      (err: any) => {
        this.toastrService.error(err);
      }
    );
  }
 //......................................getclientfmsLst.....................................
  getclientfmsLst() {
    this.getClientFMS.clientId = this.global.clientId;
    this.getClientFMS.statusLid = (this.fmsStatus != 0) ? (this.fmsStatus?.toString()) : null;
    this.CCESCare.outputValuesFMSAgency(this.getClientFMS);
    this.datafms.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.fmsagencyLst = data.result;
      },
      (err: any) => {
        this.toastrService.error(err);
      }
    );
  }
  getclienthhaLst() {
    this.getClientHHA.clientId = this.global.clientId;
    this.getClientHHA.statusLid = (this.hhaStatus != 0) ? (this.hhaStatus?.toString()) : null;
    this.CCESCare.outputValuesHHAAgency(this.getClientHHA);
    this.datahha.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.hhaagencyLst = data.result;
         
      },
      (err: any) => {
        this.toastrService.error(err);
      }
    );
  }


  //......................................evenfromcare.....................................
  evenfromcare(event) {
    this.saveclientcare.careCoordinatorId = event;
    this.saveclientcare.clientId = this.global.clientId;
    let url =
      "api/ClientCareCoordinatorRelationship/SaveClientCoordinatorRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.saveclientcare, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.careenable = false;
          document.getElementById("Careopen").click();
          this.getclientCareLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
   //......................................evenfromcare.....................................
  evenfromfms(event) {
    this.saveclientfms.fmsAgencyId = event;
    this.saveclientfms.clientId = this.global.clientId;
    let url =
      "api/ClientCareCoordinatorRelationship/SaveClientCoordinatorRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.saveclientfms, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.fmsagencyenable = false;
          document.getElementById("FMSagencyopen").click();
          this.getclientfmsLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
  evenfromhha(event) {
    this.saveclienthha.hhAgencyId = event;
    this.saveclienthha.clientId = this.global.clientId;
    let url =
      "api/ClientCareCoordinatorRelationship/SaveClientCoordinatorRelationship";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.saveclienthha, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.hhaagencyenable = false;
          document.getElementById("HHAagencyopen").click();
          this.getclienthhaLst();
          this.getClientcasemanagerandContactDetails();
        },
        (err: any) => {
          this.toastrService.error(err, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }
  //......................................getSOClist.....................................
  getSOClist() {
    let SOCparams = new URLSearchParams();
    SOCparams.append("clientId", "1");
    let url = "api/StartOfCare/GetStartOfCareList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(SOCparams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: StartOfCareBO[]) => {
          this.Lsoclist = data;
        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }
  //......................................getStartofCareList.....................................
  getStartofCareList() {
    let myParams = new URLSearchParams();
    myParams.append("clientId", this.global.clientId.toString());
    let url = "api/StartOfCare/GetStartOfCareDate?"
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any = []) => {
          this.CLientSOCList = data;
          this.CLientSOCList.forEach((element) => {
            element.Value = this.datepipe.transform(element.Value, "M/d/yyyy");
            element.Key = element.Key.toString();
          });
        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }
  //......................................getCareCoordinatordropdown.....................................
  getCareCoordinatordropdown() {
    this.assignCare = new AssignCareCoordinator();
    let url = "api/ClientCareCoordinator/getCareCoordinatordropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.CareCoordinatorDropdownList = data;
          this.CareCoordinatorDropdownList.forEach(element => {
            element.Key = element.Key?.toString();
            element.Value = element.Value?.toString();
          });

        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }
   //......................................getCareCoordinatordropdown.....................................
  getFMSAgencydropdown() {
    this.assignfms = new AssignFMSAgency();
    let url = "api/ClientFMSAgencyRelationship/GetFMSProviderNameDropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.FMSAgencyDropdownList = data;
          this.FMSAgencyDropdownList.forEach(element => {
            element.Key = element.Key?.toString();
            element.Value = element.Value?.toString();
          });

        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }
    getHHAAgencydropdown() {
    this.assignhha = new AssignHHAAgency();
    let url = "api/ClientHHAgencyRelationship/GetHHAgencyDropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.HHAAgencyDropdownList = data;
          this.HHAAgencyDropdownList.forEach(element => {
            element.Key = element.Key?.toString();
            element.Value = element.Value?.toString();
          });

        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
  }

  //......................................callingfunction.....................................
  callingfunction() {
    if (this.contactfilter == "contacts") {
      this.isRelationcontact = true;
    }
    else if (this.contactfilter == "case") {
      this.CaseStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.isRelationcontact = false;
      this.getCaseManagerDropdown()
      this.getclientCaseLst();
    }
    else if (this.contactfilter == "care") {
      this.CareStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.isRelationcontact = false;
      this.getCareCoordinatordropdown()
      this.getclientCareLst();
    }
      else if (this.contactfilter == "fms") {
      this.fmsStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.isRelationcontact = false;
      this.getFMSAgencydropdown()
      this.getclientfmsLst();
    }
         else if (this.contactfilter == "hha") {
      this.hhaStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.isRelationcontact = false;
      this.getHHAAgencydropdown()
      this.getclienthhaLst();
    }
    // else if (this.contactfilter == "House") {
    //   this.HouseStatus = this.StatusFilterLst.filter(ele=>ele.Value=="Active")[0].Key
    //   this.getHousingCoordinatordropdown()
    //   this.isRelationcontact = false;
    //   this.getclientHousingLst();
    // }
    this.getClientcasemanagerandContactDetails();
  }


  //......................................OfficeCareCoordinatordetails.....................................

  //......................................movetoUCare.....................................
  movetoUCare() {
    this.DataFromList.isEdit = false;
    this.DataFromList.isView = false;
    // this.DataFromList.isEditUCarePlan = true;
    // this.DataFromList.UCareId = 0;
    this.DataFromList.clientId = this.global.clientId;
    // this.DataFromList.isCarePlanDelete = this.DataFromList.isCarePlanDelete;
    this.EventToEdit.emit(this.DataFromList);
    this.global.globalICD10List = [];
  }

         //......................................EmitGoogleMapComponent.....................................
         EmitGoogleMapComponent(event) {
          this.ClientList.zipCode = "";
          this.ClientList.street = "";
          this.ClientList.city = "";
          this.ClientList.county = "";
          this.ClientList.state = "";
          this.ClientList.apt = "";
          let street="";
          if (
            event.address_components != null &&
            event.address_components != undefined
          ) {
            event.address_components.forEach((outerArray) => {
              outerArray?.types.forEach((innerArray) => {
                if (innerArray == "administrative_area_level_2") {
                  this.ClientList.county = outerArray.long_name;
                }
                if (innerArray == "postal_code") {
                  this.ClientList.zipCode = outerArray.long_name;
                }
                if (innerArray == "administrative_area_level_1") {
                  if (outerArray.long_name != null) {
                    let state = this.stateList?.filter(
                      (a) => a.name == outerArray.long_name
                    )[0];
      
                    this.ClientList.state = state != null ? state.abbreviation : null;
                  }
                }
                if (innerArray == "subpremise") {
                  let apt = outerArray.long_name.split(" ")[1];
                  this.ClientList.apt = (apt !=undefined && apt !=null && apt !='')? apt : outerArray.long_name;
                }
                if (innerArray == "street_number") {
                  street = (outerArray.long_name !=undefined && outerArray.long_name !=null) ? outerArray.long_name +' ' :'';            
                }
                if (innerArray == "route") {
                  this.ClientList.street = street + outerArray.short_name;
                }
              });
            });
          }
          if (event.formatted_address != null) {
            var addressFormat = event.formatted_address.split(",");
            // this.ClientList.street = addressFormat[0];
            this.ClientList.city = addressFormat[1];
          }
          this.ClientList.clientLocationLatitude = (event.clientLocationLatitude !=null && event.clientLocationLatitude !=undefined) ? event.clientLocationLatitude : null;
          this.ClientList.clientLocationLongitude = (event.clientLocationLongitude != null && event.clientLocationLongitude != undefined) ? event.clientLocationLongitude : null
          this.changevalue = event.isChanged;
          document.getElementById('openSearchAddressModal').click();
        }
      
      
          //......................................getzipcodeClient.....................................
          getzipcodeClient() {
            let myParams1 = new URLSearchParams();
            myParams1.append("Street", this.ClientList.street);
            myParams1.append("City", this.ClientList.city);
            myParams1.append("State", this.ClientList.state);
            let url = "api/Client/getZipcode?"
            this.CommonAPI
              .GetFunctionwithResponseTypeJson(myParams1, url)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(
                (data: any) => {
                  this.ClientList.zipCode = data.zipcode;
                  this.ClientList.county = data.county;
                },
                (err: any) => {
                  if (err) {
                    this.toasterService.error(err, "Error"), 8000;
                  }
                }
              );
          }
          
      
      
  //......................................getClientType.....................................
  getClientType() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", "CLIENTTYPE");
  
    this.CommonAPI.getDropDownList('CLIENTTYPE', params, url, "LovDropDown").then((data: any) => {
      
      this.TypeofClient = data.map((element: any) => ({
        id: element.id,
        lovName: element.lovName,
       
      }));
    }, (err: any) => {
      this.toastrService.error(err);
    });
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Client");
     // params.append("roleId", this.global.roleId);
     // params.append("agencyId", this.global.globalAgencyId)
      this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new authpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new authpermission();
        })
    }
  }
    public onActionFms(event) {
            this.getClientFMS.currentpageno = this.gridfmsagency.pagerModule.pagerObj.currentPage;
            this.getClientFMS.pageitem = this.gridfmsagency.pagerModule.pagerObj.pageSize;
            if (event.name == "actionBegin" && event.requestType == "filterbeforeopen") {
              this.getClientFMS.type = event.columnType
            }
          }

          public dataChangeFms(L): void {
            let val = (L.action.requestType).toString();
            if (val != "filterchoicerequest") {
              if ((L.sorted || []).length) {
                this.getClientFMS.orderColumn = L.sorted[0].name;
                this.getClientFMS.orderType = L.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
              }
            }
            if (val == "filtering" && L.action.action != "clearFilter") {
              this.getClientFMS.value = L.action.currentFilterObject.value;
              this.getClientFMS.field = L.action.currentFilterObject.field;
              this.getClientFMS.matchCase = L.action.currentFilterObject.matchCase;
              this.getClientFMS.operator = L.action.currentFilterObject.operator;
            }
            else {
              if (val == "filtering" && L.action.action == "clearFilter") {
                this.getClientFMS.field = "providerName";
                this.getClientFMS.matchCase = false;
                this.getClientFMS.operator = "contains";
                this.getClientFMS.value = "";
                this.getClientFMS.type = "string";
              }
            }
            this.getclientfmsLst();
            if (val == "paging" && L.action.name == "actionBegin") {
           
            }
          }

 public onActionHHA(event) {
            this.getClientHHA.currentpageno = this.gridhhaagency.pagerModule.pagerObj.currentPage;
            this.getClientHHA.pageitem = this.gridhhaagency.pagerModule.pagerObj.pageSize;
            if (event.name == "actionBegin" && event.requestType == "filterbeforeopen") {
              this.getClientHHA.type = event.columnType
            }
          }

          public dataChangeHHA(L): void {
            let val = (L.action.requestType).toString();
            if (val != "filterchoicerequest") {
              if ((L.sorted || []).length) {
                this.getClientHHA.orderColumn = L.sorted[0].name;
                this.getClientHHA.orderType = L.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
              }
            }
            if (val == "filtering" && L.action.action != "clearFilter") {
              this.getClientHHA.value = L.action.currentFilterObject.value;
              this.getClientHHA.field = L.action.currentFilterObject.field;
              this.getClientHHA.matchCase = L.action.currentFilterObject.matchCase;
              this.getClientHHA.operator = L.action.currentFilterObject.operator;
            }
            else {
              if (val == "filtering" && L.action.action == "clearFilter") {
                this.getClientHHA.field = "hhaName";
                this.getClientHHA.matchCase = false;
                this.getClientHHA.operator = "contains";
                this.getClientHHA.value = "";
                this.getClientHHA.type = "string";
              }
            }
            this.getclienthhaLst();
            if (val == "paging" && L.action.name == "actionBegin") {
           
            }
          }
    
openClientEmployeeMapping(): void {
  this.showQpInfoComponent = true;
   //this.getClientcasemanagerandContactDetails(); 
}

closeClientEmployeeMapping(): void {
  this.showQpInfoComponent = false;
  console.log('close call');
  this.getClientcasemanagerandContactDetails(); 
  // Optionally refresh any data if needed
}

  getClientFullName(): string {
    if (!this.ClientList) return '';
    
    const firstName = this.ClientList.firstName || '';
    const middleName = this.ClientList.middleName || '';
    const lastName = this.ClientList.lastName || '';
    
    // Format: LastName, FirstName MiddleName
    if (!firstName && !lastName) return '';
    
    let fullName = '';
    if (lastName) fullName += lastName;
    if (firstName) fullName += (fullName ? ', ' : '') + firstName;
    if (middleName) fullName += ' ' + middleName;
    
    return fullName.trim();
  }

 
  
          checkForReferral() {
  
  this.isCheckingReferral = true;

     let params = new URLSearchParams();
      params.append("MedicaId", this.ClientList?.medicaid);
      let url = "api/Client/GetCheckDuplicateMedicaId?";
      this.ClientService.GetFunctionwithResponseTypeText(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.toasterService.success("Medica ID Not Found");
            this.sessionLogout();
          },
          (err: any) => {
            this.toasterService.error(err);
            
          }
        );
  
}
  



          private eligibilityModal!: Modal;
          openEligibilityWarningModal() {
  const modalEl = document.getElementById('eligibilityWarningModal');
  if (!modalEl) return;

  this.eligibilityModal = Modal.getOrCreateInstance(modalEl, {
    backdrop: 'static',
    keyboard: false
  });

  this.eligibilityModal.show();
}
          closeEligibilityWarningModal() {
  if (this.eligibilityModal) {
    this.eligibilityModal.hide();
  }
}
warningModal!: Modal;

openWarningModal() {
  const modalEl = document.getElementById('warningModal');
  if (!modalEl) return;

  this.warningModal = Modal.getOrCreateInstance(modalEl, {
    backdrop: 'static',
    keyboard: false
  });

  this.warningModal.show();
}

closeWarningModalNew() {
  if (!this.warningModal) return;

  this.warningModal.hide();

  // ⏱ wait for Bootstrap animation to finish
  setTimeout(() => {
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    document.querySelectorAll('.modal-backdrop')
      .forEach(b => b.remove());
  }, 300); // matches Bootstrap fade duration
}
}
